import React from "react";

export const MutuelleDownloadSection = ({ mutuelle, formData }) => {
  if (!mutuelle || mutuelle === "Aucune demande de Mutuelle") return null;

  const handleDownload = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BACKEND_URL;
      const res = await fetch(`${apiUrl}/api/mutuelle/generate-pdf`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mutuelle,
          nom: formData.nom,
          prenom: formData.prenom,
          email: formData.email,
          telephone: formData.telephone,
          adresse: formData.adresse,
          montantPayer: formData.montantPayer,
          dateInscription: formData.dateInscription instanceof Date ? formData.dateInscription.toISOString().slice(0, 10) : formData.dateInscription,
          dateFinAbonnement: formData.dateFinAbonnement instanceof Date ? formData.dateFinAbonnement.toISOString().slice(0, 10) : formData.dateFinAbonnement,
        }),
      });
      if (!res.ok) throw new Error("Erreur lors de la génération du PDF");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Mutuelle_${mutuelle.replace(/ /g, "_")}_${formData.prenom}_${formData.nom}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      alert("Erreur: " + err.message);
    }
  };

  return (
    <div className="mt-6 p-5 rounded-xl bg-[#f0f7ff] border border-[#3899ec]/30" data-testid="mutuelle-download-section">
      <p className="text-sm font-semibold text-[#162d3d] mb-3">Formulaire mutuelle : {mutuelle}</p>
      <p className="text-xs text-[#577083] mb-4">Le formulaire a été pré-rempli avec les données d'inscription. Téléchargez-le et remettez-le au membre.</p>
      <button
        type="button"
        data-testid="download-mutuelle-pdf-btn"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#3899ec] hover:bg-[#2b7dca] text-white rounded-lg text-sm font-medium transition-colors"
        onClick={handleDownload}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        Télécharger le formulaire mutuelle
      </button>
    </div>
  );
};
